import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import CloseIcon from '@material-ui/icons/Close';

import AppContent from '../_Shared/Layout/AppContent';
import SlideTransition from '../_Shared/Transitions/SlideTransition';

import ExecutionComponent from './ExecutionHistory/ExecutionComponent';
import StepComponent from './ExecutionHistory/StepComponent';

const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
};

class PackageExecutionHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            executionColumns: [{field: 'status', label: 'Status', span:'2'}, {field: 'statusMessage', label: 'Status Message', span:'1'}]
        }
    }

    saveQuery = () => {
        this.props.onClose();
    }

    render() {
        const { classes, open, onClose, executions } = this.props;
        const { executionColumns } = this.state;

        return (<Dialog fullScreen open={open} onClose={onClose} TransitionComponent={SlideTransition}>                
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
                            <Typography variant="title" color="inherit" className={classes.flex}>{this.props.title}</Typography>
                        </Toolbar>
                    </AppBar>

                    <AppContent>
                    {
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan="3"></TableCell>
                                    {                            
                                        [].concat(executionColumns).map((col, colIndex) => <TableCell colSpan={col.span} key={`table_header_cell_${colIndex}`}>{col.label}</TableCell>)
                                    }
                                    <TableCell colSpan="2"></TableCell>
                                </TableRow>
                            </TableHead>
                        {
                            executions &&
                            [].concat(executions).sort((a, b) => b.order - a.order).map((execution, executionIndex) =>
                                <ExecutionComponent key={`table_execution_cell_${executionIndex}`} execution={execution} 
                                    executionIndex={executionIndex} colSpan={executionColumns.length}>
                                    {
                                        execution && execution.steps &&
                                        [].concat(execution.steps).map((step, stepIndex) =>
                                        {
                                            return (
                                                <StepComponent key={`table_execution_${executionIndex}_step_cell_${stepIndex}`} 
                                                    columns={[{field: 'queryId', label: ''}, {field: 'status', label: 'Status'}, {field: 'statusMessage', label: 'Status Message'}]} 
                                                    colSpan={executionColumns.length} step={step}>
                                                </StepComponent>
                                            );
                                        })
                                    }                         
                                </ExecutionComponent>
                            )
                        }
                        </Table>
                    }
                    </AppContent>
                </Dialog>            
        );
    }
}

PackageExecutionHistory.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PackageExecutionHistory);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageExecutionHistory.js